<script setup>
import "@/styles/css/seo-calculators.scss";
import "rangeslider.js/dist/rangeslider.css";
import "rangeslider.js";
import { onMounted, ref } from "vue";

onMounted(() => {
  require("@/assets/js/option-value.js");
});
const view = ref(false);
</script>
<template>
  <main class="seo-calculators option-value-calculator">
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a>
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>Option value calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->
    <div class="container">
      <h1 class="page-heading">Option value calculator</h1>
      <h2 class="page-sub-heading">Calculate your options value.</h2>

      <div class="container no-padding-web">
        <div class="row">
          <div class="col-md-6 no-padding">
            <div class="slider-container">
              <form name="calculator">
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Underlying Price</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="underlying"
                        value="1000"
                        min="0"
                        max="100000"
                        id="underlying-investment-input"
                      /><span>₹</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    min="0"
                    value="1000"
                    max="100000"
                    id="underlying-investment-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">₹0</div>
                    <div class="slider__max">₹100,000</div>
                  </div>
                </div>
                <!-- end of Underlying Price -->

                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Strike Price</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="strike"
                        value="5000"
                        min="0"
                        max="100000"
                        id="strike-rate-input"
                      /><span>₹</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    min="0"
                    value="12"
                    max="100000"
                    id="strike-rate-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">₹0</div>
                    <div class="slider__max">₹100,000</div>
                  </div>
                </div>
                <!-- end of Strike Price -->

                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Volatility</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="volatility"
                        value="60"
                        step="1"
                        min="0"
                        max="250"
                        id="volatility-input"
                      /><span class="m-l-4">%</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="5"
                    step="1"
                    min="0"
                    max="250"
                    id="volatility-input-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">0 %</div>
                    <div class="slider__max">250 %</div>
                  </div>
                </div>
                <!-- end of Volatility -->

                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Interest Rate</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="interest_rate"
                        value="5"
                        step="1"
                        min="0"
                        max="10"
                        id="interest-input"
                      /><span class="m-l-4">%</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="5"
                    step="1"
                    min="0"
                    max="10"
                    id="interest-input-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">0 %</div>
                    <div class="slider__max">10 %</div>
                  </div>
                </div>
                <!-- end of Dividend Yeild -->

                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Dividend Yield</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="dividend"
                        value="10"
                        step="1"
                        min="0"
                        max="20"
                        id="dividend-input"
                      /><span class="m-l-4">%</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="5"
                    step="1"
                    min="0"
                    max="20"
                    id="dividend-input-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">0 %</div>
                    <div class="slider__max">20 %</div>
                  </div>
                </div>
                <!-- end of Dividend Yeild -->

                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Days to expiration</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="expiration"
                        value="156"
                        step="1"
                        min="0"
                        max="365"
                        id="expiration-input"
                      /><span class="m-l-4">days</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="5"
                    step="1"
                    min="0"
                    max="365"
                    id="expiration-input-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">0 days</div>
                    <div class="slider__max">365 days</div>
                  </div>
                </div>
                <!-- Days to expiration -->
              </form>
            </div>
            <!-- end of slider-container -->
          </div>
          <!-- end of col-md-6 no-padding -->

          <div class="col-md-6 no-padding">
            <aside class="calculator-output">
              <div class="calculator-output__row calculator-output__row__large">
                <!-- Start of Call Price & Put Price Outputs -->
                <div
                  class="calculator-output__col calculator-output__value__large first"
                >
                  <h3 class="calculator-output__heading">Call Price</h3>
                  <div id="call-price" class="calculator-output__amount--small">
                    ₹ 2.6921
                  </div>
                </div>
                <div
                  class="calculator-output__col calculator-output__value__large"
                >
                  <h3 class="calculator-output__heading">Put Price</h3>
                  <div id="put-price" class="calculator-output__amount--small">
                    ₹ 2.0074
                  </div>
                </div>
              </div>
              <!-- end of Call Price & Put Price Outputs -->

              <div class="cta-btn">
                <a href="https://wa.me/+917092362098" class="cta"
                  >Trade Now</a
                >
              </div>

              <div class="calculator-output__row calculator-output__value">
                <!-- start of Call Delta, Put Delta & Gamma Outputs  -->
                <div class="calculator-output__col">
                  <h3 id="call-delta" class="calculator-output__heading">
                    0.5477
                  </h3>
                  <div class="calculator-output__amount--small">Call Delta</div>
                </div>
                <div class="calculator-output__col">
                  <h3 id="put-delta" class="calculator-output__heading">
                    -0.4523
                  </h3>
                  <div class="calculator-output__amount--small">Put Delta</div>
                </div>
                <div class="calculator-output__col">
                  <h3 id="gamma-value" class="calculator-output__heading">
                    0.0677
                  </h3>
                  <div class="calculator-output__amount--small">Gamma</div>
                </div>
                <div class="calculator-output__col">
                  <h3 id="vega-value" class="calculator-output__heading">
                    0.4636
                  </h3>
                  <div class="calculator-output__amount--small">Vega</div>
                </div>
                <div class="calculator-output__col">
                  <h3 id="call-theta" class="calculator-output__heading">
                    -0.3065
                  </h3>
                  <div class="calculator-output__amount--small">Call Theta</div>
                </div>
                <div class="calculator-output__col">
                  <h3 id="put-theta" class="calculator-output__heading">
                    -0.1696
                  </h3>
                  <div class="calculator-output__amount--small">Put Theta</div>
                </div>
                <div class="calculator-output__col">
                  <h3 id="call-rho" class="calculator-output__heading">
                    0.0747
                  </h3>
                  <div class="calculator-output__amount--small">Call Rho</div>
                </div>
                <div class="calculator-output__col">
                  <h3 id="put-rho" class="calculator-output__heading">
                    -0.0622
                  </h3>
                  <div class="calculator-output__amount--small">Put Rho</div>
                </div>
              </div>
              <!-- end of Call Delta, Put Delta & Gamma Outputs  -->
            </aside>
          </div>
        </div>
        <!-- end of row -->
      </div>
    </div>

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>Option Value Calculator</h2>
      <p></p>
      <p>
        <span style="font-weight: 400"
          >Are you planning to purchase an extra garage space with your
          apartment even though you are not certain of using it? Or are you
          thinking of pursuing a higher degree in statistics with a bachelor’s
          in chemical engineering just to broaden your career choices? Then
          you’re already buying options.</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >As a financial product, options or derivatives offer the advantages
          of leverage, low capital requirement, diversification and high
          risk-reward ratio to the investors. However, they come with trade-offs
          such as lower liquidity, higher risk, complexity of the trade and
          higher spreads. Therefore, it is critical for the investor to weigh
          the pay-offs before allocating resources to option trading.</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >The subject of option value is technical with nuanced terms and is
          likely to be perceived as complicated by first-time
          traders/investors.</span
        >
      </p>
      <p>
        <span style="font-weight: 400"
          >So let’s attempt to decode the nuances related to option value.
        </span>
      </p>
      <p></p>
    </section>

    <!-- Calculator Faqs Section-->

    <section class="container calculator_help_section">
      <h2 class="fs-28 bold help_here">Frequently Asked Questions</h2>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse1"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What are options?</span>
                </span>
              </h3>
            </div>
            <div id="collapse1" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  Options are financial contracts that offer the buyer a right,
                  but not an obligation, to buy or sell an asset on a specific
                  date at a particular price called the strike price, which is
                  predetermined at the date on which the option is being
                  purchased or sold.
                </p>
                <p class="visible">
                  Thus, buyers can exercise the contract only if they feel that
                  there is going to be a potential benefit. Otherwise, they can
                  simply let go of the contract by not exercising it.
                </p>
                <p class="visible">
                  As a derivative product, options derive their value from an
                  <a
                    href="/learning-center/futures-and-options/what-is-an-underlying-asset/"
                    >underlying asset</a
                  >
                  such as Stocks, bonds, indices, foreign currencies and even
                  commodities. There are basically two kinds of options: call
                  options (which give the trader an option to buy the underlying
                  asset) and put options (which give the trader an option to
                  sell the underlying asset).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse2"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What are the types of options?</span>
                </span>
              </h3>
            </div>
            <div id="collapse2" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  The European option can be exercised only at the expiration
                  date, whereas the American Option can be exercised anytime
                  before the expiration date when the option holder desires.
                  Since 2010, all options in India are European options.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse3"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What are Option Greeks?</span>
                </span>
              </h3>
            </div>
            <div id="collapse3" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  The price of an option is a function of many variables such as
                  time to maturity, underlying volatility,
                  <a
                    href="/learning-center/futures-and-options/what-is-spot-price/"
                    >spot price</a
                  >
                  of underlying asset, strike price and interest rate, it is
                  critical for the option trader to know how the changes in
                  these variables affect the option price or option premium. The
                  Option Greeks sensitivity measures capture the extent of risk
                  related to options trading.
                </p>
                <p class="visible">
                  The sensitivity measures are Delta, Gamma, Theta, Vega and Rho
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse4"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is Delta?</span>
                </span>
              </h3>
            </div>
            <div id="collapse4" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  As an investor or trader, one may seek an answer to how much
                  will the price of my option move if the stock moves ₹1? That’s
                  where “delta” comes in. Delta is the amount an option price is
                  expected to move based on a ₹1 change in the underlying stock.
                  Calls have positive delta, between 0 and 1. If the stock price
                  rises and other pricing variables remain constant, then the
                  price for the call will go up.
                </p>
                <p class="visible">
                  For example:If a call has a delta of 0.75 and the stock goes
                  up ₹1, in theory, the price of the call will go up about
                  ₹0.75. If the stock goes down ₹1, in theory, the price of the
                  call will go down about ₹0.75.
                </p>
                <p class="visible">
                  Puts have a negative delta, between 0 and -1. If the stock
                  price rises and all other variables remain unchanged, then the
                  price of the option will go down.
                </p>
                <p class="visible">
                  For example, if a put has a delta of -0.70 and the stock goes
                  up ₹1, in theory, the price of the put will go down ₹0.70. If
                  the stock goes down ₹1, in theory, the price of the put will
                  go up ₹0.70.
                </p>
                <p class="visible">
                  As a thumb rule, in-the-money options will move more than
                  out-of-the-money options, and short-term options will react
                  more than longer-term options to the same price change in the
                  stock.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse5"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is Gamma?</span>
                </span>
              </h3>
            </div>
            <div id="collapse5" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  It is the rate that delta will change based on a ₹1 change in
                  the stock price. So if delta is the “speed” at which option
                  prices change, gamma is the “acceleration.” Options with the
                  highest gamma are the most responsive to changes in the price
                  of the underlying stock.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse6"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is Time decay, or theta?</span>
                </span>
              </h3>
            </div>
            <div id="collapse6" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  Theta is the amount the price of calls and puts will decrease
                  for a one-day change in the time to expiration. Therefore,
                  at-the-money options are likely to have relatively significant
                  rupee losses over time than in- or out-of-the-money options
                  with the same underlying stock and expiration date. This is
                  because at-the-money options have the most time value built
                  into the premium. And the bigger the span of time value built
                  into the price, the more is the downside.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse7"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is Vega?</span>
                </span>
              </h3>
            </div>
            <div id="collapse7" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  It is the amount call and put prices will change, in theory,
                  for a corresponding one-point change in implied volatility.
                  Vega does not have any effect on the intrinsic value of
                  options; it only affects the “time value” of an option’s
                  price. Typically, as implied volatility increases, the value
                  of options will increase. That’s because an increase in
                  implied volatility suggests an increased range of potential
                  movement for the stock.
                </p>
                <p class="visible">
                  For example, a 30-day option on stock ABC with a ₹40 strike
                  price and the stock exactly at ₹40. Vega for this option might
                  be 0.03. In other words, the value of the option might go up
                  ₹0.03 if implied volatility increases one point, and the value
                  of the option might go down ₹0.03 if implied volatility
                  decreases one point.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse8"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is Rho?</span>
                </span>
              </h3>
            </div>
            <div id="collapse8" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  To get the output, the user must input all the following
                  variables: underlying, market price and strike price,
                  transaction and expiry date, rate of interest, implied
                  volatility and the type of option (i.e. call option or put
                  option) and accordingly evaluate the output.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse9"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >What are the key inputs or dependent variables to be
                    plugged in the option value calculator?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse9" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  To get the output, the user must input all the following
                  variables: underlying, market price and strike price,
                  transaction and expiry date, rate of interest, implied
                  volatility and the type of option (i.e. call option or put
                  option) and accordingly evaluate the output.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span
                  class="panel-trigger"
                  data-toggle="collapse"
                  href="#collapse10"
                >
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Can this tool be used for the index option also?</span>
                </span>
              </h3>
            </div>
            <div id="collapse10" class="panel-collapse collapse">
              <div class="panel-body">
                <p class="visible">
                  Yes, our option value calculator can be used for both index
                  options (such as Nifty50 and Bank Nifty) as well as stock
                  options.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button
            class="similar-btn btn-all"
            v-if="!view"
            @click="view = !view"
          >
            View all
          </button>
          <button
            class="similar-btn btn-less"
            v-if="view"
            @click="view = !view"
          >
            View less
          </button>
        </div>
        <div class="smooth-wrap" :class="[view ? 'smooth-wrap2' : '']">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Brokerage Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Margin Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Mutual Fund Returns Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SIP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPV Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Future Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SWP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> ELSS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> PPF Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Annual Growth Rate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> National Savings Certificate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Sukanya Samriddhi Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Atal Pension Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Gratuity calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Simple Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Fixed Deposit Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> GST Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> HRA Calculator</a>
            </h3>
          </div>
        </div>
      </div>
    </section>

    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <p></p>
      <p>
        Disclaimer:<br />
        This calculator is meant to be used for indicative purposes only. It is
        designed to assist you in determining the appropriate amount of
        prospective investments. This calculator alone is not sufficient and
        shouldn’t be used for the development or implementation of any
        investment strategy. Upstox does not take the responsibility/liability
        nor does it undertake the authenticity of the figures calculated
        therein. Upstox makes no warranty about the accuracy of the
        calculators/reckoners. The examples do not claim to represent the
        performance of any security or investments. In view of the individual
        nature of tax consequences, each investor is advised to consult his/her
        own professional tax advisor before making any investment decisions on
        the basis of the results provided through the use of this calculator.
      </p>
      <p></p>
    </section>
  </main>
</template>
<style scoped>
</style>
